import React from 'react'
import DiscussProjet from '../components/DiscussProjet'

function ContactPage() {
  return (
<DiscussProjet />  )
}

export default ContactPage